import React, { useState } from 'react';
import { useFormik } from 'formik';
import { object, string } from 'yup';
import { Link } from 'react-router-dom';
import Layout from '../../components/Layout';
import Input from '../../components/form/Input';
import { useMutation } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';
import { FiChevronLeft } from 'react-icons/fi';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';
import { userGroups } from '../../context/AuthContext';
const phoneUtil = PhoneNumberUtil.getInstance();

export const ADD_USER = gql`
    mutation createUser($input: CreateGatewayUserInput!) {
        createUser(input: $input) {
            sub
            email
        }
    }
`;

const UserCreate = () => {
    const [addUser] = useMutation(ADD_USER);
    const [error, setError] = useState(null);
    const [showSuccess, setShowSuccess] = useState(false);
    const handleSave = async (values) => {
        try {
            let phone = '';
            if (values.phone_number) {
                let number = phoneUtil.parse(values.phone_number, 'US');
                phone = phoneUtil.format(number, PhoneNumberFormat.E164);
            }

            await addUser({
                variables: { input: { ...values, phone_number: phone, groups: [] } }
            });
            setShowSuccess(true);
        } catch (err) {
            const error = err?.graphQLErrors[0];
            if (error.errorType === 'Unauthorized') {
                setError('You are not authorized to add a new user.');
            }
        }
    };

    const form = useFormik({
        initialValues: {
            email: '',
            given_name: '',
            family_name: '',
            phone_number: ''
        },
        validationSchema: object().shape({
            email: string().email('Please use a valid email address').required('Email is required'),
            given_name: string().required('First Name is required'),
            family_name: string().required('Last Name is required'),
            phone_number: string().test('is-phone', 'Phone number is not valid', (value) => {
                try {
                    if (!value) {
                        return true;
                    }
                    let number = phoneUtil.parse(value, 'US');
                    if (!number) {
                        return false;
                    }
                    return phoneUtil.isValidNumber(number);
                } catch (err) {
                    return false;
                }
            })
        }),
        onSubmit: handleSave
    });

    return (
        <Layout requiresGroup={userGroups.ADMIN}>
            <p>
                <Link to="/admin/users">
                    <FiChevronLeft className="icon" /> Back to Users
                </Link>
            </p>
            <h1 className="mb-4">Add User</h1>
            <form onSubmit={form.handleSubmit} noValidate>
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <Input id="given_name" label="First Name" context={form} required />
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <Input id="family_name" label="Last Name" context={form} required />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-md-6">
                        <Input id="email" label="Email" context={form} required />
                    </div>
                    <div className="col-xs-12 col-md-6">
                        <Input id="phone_number" label="Phone Number" context={form} />
                    </div>
                </div>

                <button className="btn btn-primary" type="submit">
                    Create User
                </button>
                {error && <div className="flash flash-danger mt-4">{error}</div>}
                {showSuccess && (
                    <div className="flash flash-success mt-4">
                        <strong>User created successfully.</strong>
                        <br />
                        User will receive a temporary password in their email.
                        <br />
                        <Link to="/admin/users">Back to Users</Link>
                    </div>
                )}
            </form>
        </Layout>
    );
};

export default UserCreate;
